module.exports = __webpack_public_path__ + "static/media/Hand_of_user.eba97968.png";